<template>
    <div class="page-scan">

      
       

        <img :src="scanImg" @click="toScanCode" class="scanImg"/>
      <!-- 扫描盒子 -->
        <div class="scan-box" v-if="scanTextData.showScanBox">
            <div class="scan-cacel" @click="cancelScan">
            <!-- <img src="" alt=""> -->
            取消
            </div>
            <div class="toPhoto">
              <p><van-icon name="photo" /></p>
              相册
              <input type="file" accept="image/png, image/jpeg" @change="changeFile"> </input>
            </div>
            <canvas id="mycanvas" style="position:absolute;opacity: 0"></canvas>
            <video ref="video" id="video" class="scan-video" v-show="scanTextData.showScanBoxInfo" autoplay></video>
            <div class="scan-img" v-show="scanTextData.showScanBoxInfo">
            <div class="scan-frame">
                <span class="left-t"></span>
                <span class="right-t"></span>
                <span class="left-b"></span>
                <span class="right-b"></span>
                <span class="cross-line"></span>
            </div>
            </div>
            <!-- <img  src="/static/img/scan.svg" alt="" v-show="scanTextData.showScanBoxInfo"> -->
            <div class="scan-tip"> {{scanTextData.tipMsg}} </div>
      </div>
      
    </div>
  </template>
  
  
  <script>
    // import Vue from 'vue'
    // import VConsole from 'vconsole';
// Vue.prototype.Vconsole = new VConsole()
  import { BrowserMultiFormatReader } from '@zxing/library';
  import jsQR from "jsqr"
import { json } from 'body-parser';
import { Toast } from 'vant';
  let scanTextData = {
    loadingShow: false,
    codeReader: null,
    scanText: '',
    vin: null,
    tipMsg: '将二维码置于屏幕中，即可识别',
    tipShow: false,
  }
    export default {
      name: 'scanCodePage',
      data() {
        return {
            scanImg:'https://pkusaas.oss-cn-beijing.aliyuncs.com/miniprogram/study_center/exchangeScan.png',

          scanTextData:{
              loadingShow: false,
              codeReader: null,
              scanText: '',
              vin: null,
              tipMsg: '正在调用摄像头...',
              tipShow: false,
  
              showScanBox:false,
              showScanBoxInfo:false,
          },
          hasBind:false,
          result: "",
        }
      },
    //   created () {
    //   // 扩展API是否准备好，如果没有则监听“plusready"事件
    //   if (window.plus) {
    //     this.plusReady()
    //   } else {
    //     document.addEventListener('plusready', this.plusReady, false) 
    //   }
    // },
      methods: {
        changeFile(e) {
                var that = this;
                that.result = "请上传二维码";
                var fileReader = new FileReader();

                fileReader.onload = function(event) {
                    var data = event.target.result;
                    // console.dir(data);
                    var img = new Image();
                    img.src = data;

                    img.onload = function() {
                        var mycanvas = document.getElementById("mycanvas");
                        var ctx = mycanvas.getContext("2d");
                        // canvas 的width/height重新设置的时候会清空画布
                        mycanvas.width = img.width;
                        mycanvas.height = img.height;

                        ctx.drawImage(img, 0, 0);
                        var imageData = ctx.getImageData(0, 0, img.width, img.height);
                        const code = jsQR(imageData.data, imageData.width, imageData.height, {
                            inversionAttempts: "dontInvert",
                        });
                        if (code) {
                          that.scanTextData.showScanBox = false
                          that.scanTextData.showScanBoxInfo = false
                          //这里扫描出结果可以调用你想要的方法
                          //识别完停止使用摄像头
                          let thisVideo = document.getElementById("video");
                          if(thisVideo.srcObject){
                            thisVideo.srcObject.getTracks()[0].stop()
                            that.scanTextData.codeReader.reset(); // 重置
                          }
                          
                            that.$emit('scanResult',code.data)

                            // console.log(code.data);
                        } else {
                            Toast("识别错误");
                        }
                        that.result = code.data;
                    }
                }
                fileReader.readAsDataURL(e.target.files[0]);
            },
          toScanCode(){
              this.scanTextData.codeReader = new BrowserMultiFormatReader();
              this.scanTextData.showScanBox = true
              this.openScan();
              
          },
          cancelScan(){
              //识别完停止使用摄像头
              let thisVideo = document.getElementById("video");
              if(thisVideo.srcObject){
                thisVideo.srcObject.getTracks()[0].stop()
                this.scanTextData.codeReader.reset(); // 重置
              }
              
              this.scanTextData.showScanBox = false
              setTimeout(()=>{
                this.scanTextData.showScanBoxInfo = false
              },1000)
          },
  
          async openScan() {
              this.scanTextData.codeReader.getVideoInputDevices().then((videoInputDevices) => {
                this.scanTextData.tipShow = true;
                this.scanTextData.tipMsg = '正在调用摄像头...';
                console.log('videoInputDevices', videoInputDevices);
              // 默认获取第一个摄像头设备id
                let firstDeviceId = videoInputDevices[0].deviceId;
                // 获取第一个摄像头设备的名称
                const videoInputDeviceslablestr = JSON.stringify(videoInputDevices[0].label);
                if (videoInputDevices.length > 1) {
                  // 判断是否后置摄像头
                  if (videoInputDeviceslablestr.indexOf('back') > -1) {
                  firstDeviceId = videoInputDevices[0].deviceId;
                  } else {
                  firstDeviceId = videoInputDevices[1].deviceId;
                  }
                }
                this.decodeFromInputVideoFunc(firstDeviceId);
                }).catch(err => {
                  console.log('err')
                // this.scanTextData.tipShow = false;
                this.scanTextData.tipMsg = '摄像头调起失败，请选择相册照片...';
                console.error(err);
              })
          },
          decodeFromInputVideoFunc(firstDeviceId) {
            this.scanTextData.codeReader.reset(); // 重置
            this.scanTextData.codeReader.decodeFromInputVideoDeviceContinuously(firstDeviceId, 'video', (result, err) => {
                this.scanTextData.tipMsg = '将二维码置于屏幕中，即可识别';
              setTimeout(()=>{
                  this.scanTextData.showScanBoxInfo = true
              },1000)
              if (result) {
                  console.log('扫描结果', result.text);
                  if (result.text) {
                        console.log('扫描结果11', result.text);
                        this.scanTextData.showScanBox = false
                        this.scanTextData.showScanBoxInfo = false
                        //这里扫描出结果可以调用你想要的方法
                        //识别完停止使用摄像头
                        let thisVideo = document.getElementById("video");
                        thisVideo.srcObject.getTracks()[0].stop()
                        this.scanTextData.codeReader.reset(); // 重置
                        this.$emit('scanResult',result.text)
                  }
              }else{
                  // console.log('没出来？',result,err)
              }
              if (err && !(err)) {
                this.scanTextData.tipMsg = '识别失败';
                  setTimeout(() => {
                    this.scanTextData.tipShow = false;
                  }, 2000)
                  console.error(err);
              }
              });
          },
    
      },
      props:['dataObj']
    }
  </script>
  
  
  <style scoped lang="scss">
    
  
  
    .scan-index-bar{
      background-image: linear-gradient( -45deg, #42a5ff ,#59cfff);
    }
    .van-nav-bar__title{
      color: #fff !important;
    }
    .scan-box{
      position: fixed;
      top: 0;
      left: 0;
      z-index: 5;
      height: 100vh;
      width: 100vw;
      background: #000;
      .scan-cacel{
        position: absolute;
        top: 30px;
        left: 30px;
        z-index: 9;
        color: #fff;
        font-size: 35px;
      }
      .toPhoto{
        position: absolute;
        bottom:1rem;
        right:3vw;
        z-index: 9;
        width: 10vw;
        text-align: center;
        color: #fff;
        line-height: 0.4rem;
        p{
          width: 10vw;
          height: 10vw;
          background: #4e4e4e;
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          margin-bottom: 0.3rem;
          i{
            font-size: 0.48rem;
          }
        }
        input{
          width: 100%;
          height: 100%;
          opacity: 0;
          position: absolute;
          left: 0;
          top:0;
          z-index: 10;
        }
      }
    }
    .scan-video{
      height: 100vh;
      width: 100vw;
      object-fit:cover;
    }
    .scan-img{
      width: 500px;
      height: 500px;
      position: fixed;
      top: 40%;
      left: 50%;
      margin-top: -200px;
      margin-left: -250px;
      z-index: 6;
      .scan-frame{
        width: 100%;
        height: 100%;
        position: relative;
        .left-t,.right-t,.left-b,.right-b{
          position: absolute;
          width: 80px;
          height: 80px;
        }
        .left-t{
          top: 0;
          left: 0;
          border-top:2px solid #17B1B7;
          border-left:2px solid #17B1B7;
        }
        .right-t{
          top: 0;
          right: 0;
          border-top:2px solid #17B1B7;
          border-right:2px solid #17B1B7;
        }
        .left-b{
          bottom: 0;
          left: 0;
          border-bottom:2px solid #17B1B7;
          border-left:2px solid #17B1B7;
        }
        .right-b{
          bottom: 0;
          right: 0;
          border-bottom:2px solid #17B1B7;
          border-right:2px solid #17B1B7;
        }
        .cross-line{
          width: 600px;
          height: 10px;
          background: linear-gradient(to right, rgba(255, 255, 255, 0),#5DDDD3,rgba(255,255,255,0));
          position: absolute;
          top: 0;
          left: -50px;
          animation: identifier_p 5s infinite;
        }
        @keyframes identifier_p {
          0%{
            top: 0%;
          }
          50%{
            top: 100%;
          }
          100%{
            top: 0;
          }
        }
      }
    }
    .scan-tip{
      width: 100vw;
      text-align: center;
      margin-bottom: 10vh;
      color: white;
      font-size: 24px;
      position: absolute;
      bottom: 50px;
      left: 0;
      color: #fff;
    }
    .page-scan{
      overflow-y: hidden;
     
        .scanImg{
            width: 38px;
            height: 38px;
            display: block;
        }
      // background-color: #363636;
    }
  </style>
  